import React, { useState, useEffect } from "react";

const TruncateWithTooltip = ({ text, maxLength = 18 }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const displayText =
    text.length > maxLength ? text.slice(0, maxLength) + "..." : text;

  const handleClick = () => {
    if (isMobile) setShowTooltip(!showTooltip);
  };

  return (
    <div
      className="relative inline-block max-w-full cursor-pointer"
      onClick={handleClick}
      onMouseEnter={() => !isMobile && setShowTooltip(true)}
      onMouseLeave={() => !isMobile && setShowTooltip(false)}
    >
      <span className="truncate block max-w-[150px] ">{displayText}</span>
      {showTooltip && (
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 z-50 mb-1 px-3 py-2 bg-black text-white text-xs rounded shadow-lg whitespace-nowrap">
          {text}
        </div>
      )}
    </div>
  );
};

export default TruncateWithTooltip;
